// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './polyfill'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import Loading from 'vue-loading-overlay'
import VueScrollTo from 'vue-scrollto'
import App from './App'
import router from './router'
import i18n from './i18n'
import './addons'
import './global-filters'
import './directives'
import store from './vuex'
import VueApexCharts from 'vue-apexcharts'

Vue.use(BootstrapVue)
Vue.use(VueApexCharts)
Vue.use(Loading, {
    width: 40,
    height: 40,
    zIndex: 999,
    opacity: 0.6,
    color: '#3AB2E3',
    loader: 'spinner',
    enforceFocus: false,
    backgroundColor: '#ffffff',
})

Vue.use(VueScrollTo, {
    container: 'body',
    duration: 700,
    easing: 'ease-in',
    offset: 0,
    force: true,
    // lazy: false,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true,
})

Vue.component('apexchart', VueApexCharts)

export const EventBuzz = new Vue()

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    i18n,
    components: {
        App,
    },
})

//Please, remove this comment!
